(ns dashboard.components.notifications
  (:require [re-frame.core :as rf]
            [dashboard.subs :as common-subs]))

(defn notifications-container [{:keys [on-delete-notification notifications]}]
  (let [{:keys [notifications-up]} @(rf/subscribe [::common-subs/user-preferences])]
    [:div.is-flex
     {:style {:position       "fixed"
              :bottom         0
              :right          0
              :width          "95vw"
              :max-width      "740px"
              :height         "100vh"
              :pointer-events "none"
              :z-index        2000}
      :class [(if notifications-up
                "is-flex-direction-column"
                "is-flex-direction-column-reverse")
              "is-align-items-stretch"]}
     (->> notifications
          (group-by :message)
          (map
           (fn [[message coll]]
             (let [{:keys [class] :as notif} (first coll)]
              [:div.notification.mr-3.my-0.py-1.has-text-light.slide-in-and-fadeout-5sec
              {:key   (str (:id notif))
               :style {:border "1px solid rgba(22,22,22,0.01)"
                       :pointer-events "visible"}
               :class (or class "is-success")
               :on-click #(on-delete-notification notif)}
              [:button.delete.is-rounded.py-1.my-0
               {:on-click #(on-delete-notification notif)}]
              [:b.is-size-5
               (str message
                   (when (> (count coll) 1)
                     (str " X " (count coll))))]])))
          (into [:nav.is-fixed-bottom]))]))
